import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';

import { Page404Component } from './extrapages/page404/page404.component';
import { CoachAuthGuard } from './core/guards/coach-auth.guard';
import { TermsAndConditionComponent } from './shared/ui/terms-and-condition/terms-and-condition.component';
import { TermsAndConditionGermanComponent } from './shared/ui/terms-and-condition-german/terms-and-condition-german.component';
import { ApprovalHandlerComponent } from './extrapages/approval-handler/approval-handler.component';
import { PrintTableComponent } from './layouts/print-table/print-table.component';
import { CoacheeDpaComponent } from './shared/ui/coachee-dpa/coachee-dpa.component';
import { CoacheeAiAgreementComponent } from './shared/ui/coachee-ai-agreement/coachee-ai-agreement.component';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  // tslint:disable-next-line: max-line-length
  {path: 'print', component: PrintTableComponent},
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages-coach/pages-coach.module').then(m => m.PagesCoachModule), canActivate: [CoachAuthGuard] },
  { path:'terms-and-conditions', component: TermsAndConditionComponent},
  { path:'terms-and-conditions-de', component: TermsAndConditionGermanComponent},
  { path: 'coachee-ai-agreement', component: CoacheeAiAgreementComponent },
  { path:'coachee-dpa', component: CoacheeDpaComponent},
  { path: 'approvals/coaching', component: ApprovalHandlerComponent },

  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
